import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import i18next from "i18next";
import Cookies from "js-cookie";
i18next.use(initReactI18next).init({
  // fallbackLng: "en",
  // lng: "en",
  fallbackLng: Cookies.get("language"),
  lng: Cookies.get("language"),
  resources: {
    en: { translations: require("./en/translations.json") },
    fa: { translations: require("./fa/translations.json") },
    ku: { translations: require("./ku/translations.json") },
  },
  ns: ["translations"],
  defaultNS: "translations",
});
i18n.languages = ["en", "fa", "ku"];
export default i18n;
